export enum PaymentReceiptType {
  PRODUCT_BUYING = 'PRODUCT_BUYING',
  SUBSCRIPTION_BUYING = 'SUBSCRIPTION_BUYING',
  WALLET_TO_WALLET = 'WALLET_TO_WALLET'
}
